import EnrolmentsAdapter from './base';

export default class Schema extends EnrolmentsAdapter {
  modelNamePlural = 'schemas';
}
